// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3nJKt","author":"Table_author__JDK4g","authorImage":"Table_authorImage__1npVv","unreadRow":"Table_unreadRow__2ZWvv"};